// naming convention follows https://theme-ui.com/theme-spec
const breakpoints = ["768px"] as const;

export const mediaQueries = {
  md: `@media (min-width: ${breakpoints[0]})`,
  mdRaw: `(min-width: ${breakpoints[0]})`,
};

export const defaultTheme = {
  "--mz-font-family-sans": "Roboto, sans-serif",
  "--mz-color-primary": "65 139 202",
  "--mz-color-secondary": "255 193 6",
  "--mz-color-primary-contrast": "255 255 255",
  "--mz-color-secondary-contrast": "0 0 0",
  "--mz-color-error": "207 0 0",
  "--mz-header-height": "50px",
  "--mz-header-logo-height": "20px",
};

export type ThemeType = typeof defaultTheme;

export const setTheme = (theme: ThemeType) => {
  const root = document.documentElement;
  Object.entries(theme).forEach(([property, value]) => {
    root.style.setProperty(property, value);
  });
};
